// extracted by mini-css-extract-plugin
export default {"main":"Experience_main__bDEff","wrapper":"Experience_wrapper__o7xug","cardWrapper":"Experience_cardWrapper__q0ltU"};